import React, { useState, useEffect } from 'react';
import API_URL from '../api/APIUrl';
import { Circles } from 'react-loader-spinner';


const StudentRegister = () => {
  const [firstname, setFirstname] = useState('');
  const [middlename, setMiddlename] = useState('');
  const [surname, setSurname] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [current_address, setCurrentAddress] = useState('');
  const [permanent_address, setPermanentAddress] = useState('');
  const [last_3_years_academic_performance, set3YearsAcademicPerformance] = useState('');
  const [education_category, setEducationCategory] = useState('');
  const [need_financial_help_for, setNeedFinancialHelpFor] = useState('');
  const [institution_name, setInstitutionName] = useState('');
  const [religion, setReligion] = useState('');
  const [student_whatsapp, setStudentWhatsapp] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [father_whatsapp, setFatherWhatsapp] = useState('');
  const [mother_whatsapp, setMotherWhatsapp] = useState('');
  const [total_fees, setTotalFees] = useState('');
  const [arranged_amount, setArrangedAmount] = useState('');
  const [payment_deadline, setPaymentDeadline] = useState('');
  const [emptyFields, setEmptyFields] = useState([]);
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);

  const [isSaved, setIsSaved] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state

  const [allReligions, setAllReligions] = useState([]);
  const [allReligionsError, setAllReligionsError] = useState(null);

  const [allStates, setAllStates] = useState([]);
  const [allStatesError, setAllStatesError] = useState(null);

  const [allCities, setAllCities] = useState([]);
  const [allCitiesError, setAllCitiesError] = useState(null);

  // This useEffect will run each time `isSaved` is updated
  useEffect(() => {
    if (isSaved) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsSaved(false); // Reset the save status after scrolling
    }
  }, [isSaved]);

  const stateChange = (event) => {
    setAllCities('');
    setCity('');
    setState(event.target.value);
  };

  useEffect(() => {
    const fetchAllCities = async () => {
      const response = await fetch(API_URL.GET_ALL_CITIES + state);
      const json = await response.json();
      if (response.ok) {
        setAllCities(json);
      } else {
        setAllCities('');
      }
    };
    if (state) {
      fetchAllCities();
    }
  }, [state]);

  useEffect(() => {
    const fetchAllReligions = async () => {
      const response = await fetch(API_URL.GET_ALL_RELIGION);
      const json = await response.json();
      if (response.ok) {
        setAllReligions(json);
      } else {
        setAllReligions(null);
        setAllReligionsError('No religion data found!');
      }
    };

    fetchAllReligions();
  }, []);

  useEffect(() => {
    const fetchAllStates = async () => {
      const response = await fetch(API_URL.GET_ALL_STATES);
      const json = await response.json();
      if (response.ok) {
        setAllStates(json);
      } else {
        setAllStates(null);
        setAllStatesError('No states data found!');
      }
    };

    fetchAllStates();
  }, []);


  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      setLoading(true);

      // caste and sub_caste dropdowns are hidden, so empty strings are always sent to the DB
      const studentData = {
        firstname, middlename, surname, gender, dob, state, city, zipcode,
        current_address, permanent_address, last_3_years_academic_performance,
        education_category, need_financial_help_for, institution_name, religion,
        caste: "",
        sub_caste: "",
        student_whatsapp, email, password, father_whatsapp, mother_whatsapp,
        total_fees, arranged_amount, payment_deadline
      };

      const response = await fetch(API_URL.POST_CREATE_STUDENT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(studentData),
      });
      const json = await response.json();
      if (!response.ok) {
        setMsg('');
        setError(json.error);
        if (json.requiredFields) {
          setEmptyFields(json.requiredFields);
          console.log(json.requiredFields);
        }
        setIsSaved(true);
        setLoading(false);
      }
      if (response.ok) {
        setFirstname('');
        setMiddlename('');
        setSurname('');
        setGender('');
        setDob('');
        setState('');
        setCity('');
        setZipcode('');
        setCurrentAddress('');
        setPermanentAddress('');
        set3YearsAcademicPerformance('');
        setEducationCategory('');
        setNeedFinancialHelpFor('');
        setInstitutionName('');
        setReligion('');
        setStudentWhatsapp('');
        setEmail('');
        setPassword('');
        setFatherWhatsapp('');
        setMotherWhatsapp('');
        setTotalFees('');
        setArrangedAmount('');
        setPaymentDeadline('');

        setError(null);
        setMsg(json.message);
        setEmptyFields([]);
        console.log("New Student Created", json);

        setIsSaved(true);
        setLoading(false);
      }
    }
    catch (error) {
      setError(error.message);
      setLoading(false);
      setIsSaved(true);
    }
  };

  return (
    <form style={styles.form}>
      <h2 style={styles.title}>Student Registration</h2>
      {error && <div className="error-message">{error}</div>}
      {msg && <div className="success-message">{msg}</div>}

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>First Name</label>
          <input type="text"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
            className={`form-control ${emptyFields.includes('firstname') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Middle Name</label>
          <input type="text" value={middlename}
            onChange={(e) => setMiddlename(e.target.value)}
            className={`form-control ${emptyFields.includes('middlename') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Surname</label>
          <input type="text" value={surname}
            onChange={(e) => setSurname(e.target.value)}
            className={`form-control ${emptyFields.includes('surname') ? 'error' : ''}`}
            style={styles.input} />
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Gender</label>

          <select
            className={`form-control ${emptyFields.includes('gender') ? 'error' : ''}`}
            onChange={(e) => setGender(e.target.value)}
            value={gender}
            style={styles.input}
          >
            <option value="">Select</option>
            <option data-pg="male" value="Male">Male</option>
            <option data-pg="female" value="Female">Female</option>
          </select>
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Date of Birth</label>
          <input type="date" value={dob}
            onChange={(e) => setDob(e.target.value)}
            className={`form-control ${emptyFields.includes('dob') ? 'error' : ''}`}
            style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>State</label>

          <select
            className={`form-control ${emptyFields.includes('state') ? 'error' : ''}`}
            onChange={stateChange}
            value={state}
            style={styles.input}
          >
            <option value="">Select</option>
            {allStates && allStates.map((state) => (
              <option key={state._id} data-pg={state._id} value={state._id}>{state.title}</option>
            ))}
          </select>
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>City</label>

          <select
            className={`form-control ${emptyFields.includes('city') ? 'error' : ''}`}
            onChange={(e) => setCity(e.target.value)}
            value={city}
            style={styles.input}
          >
            <option value="">Select</option>
            {allCities && allCities.map((city) => (
              <option key={city._id} data-pg={city._id} value={city._id}>{city.title}</option>
            ))}
          </select>
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Zipcode</label>
          <input type="text" value={zipcode}
            onChange={(e) => setZipcode(e.target.value)}
            className={`form-control ${emptyFields.includes('zipcode') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Current Address</label>
          <input type="text" value={current_address}
            onChange={(e) => setCurrentAddress(e.target.value)}
            className={`form-control ${emptyFields.includes('current_address') ? 'error' : ''}`}
            style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Permanent Address</label>
          <input type="text" value={permanent_address}
            onChange={(e) => setPermanentAddress(e.target.value)}
            className={`form-control ${emptyFields.includes('permanent_address') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Last 3 Years Academic Performance</label>
          <input type="text" value={last_3_years_academic_performance}
            onChange={(e) => set3YearsAcademicPerformance(e.target.value)}
            className={`form-control ${emptyFields.includes('last_3_years_academic_performance') ? 'error' : ''}`}
            style={styles.input} />
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Education Category</label>

          <select
            className={`form-control ${emptyFields.includes('education_category') ? 'error' : ''}`}
            onChange={(e) => setEducationCategory(e.target.value)}
            value={education_category}
            style={styles.input}
          >
            <option value="">Select</option>
            <option value="Pre-Primary (LKG to UKG)">Pre-Primary (LKG to UKG)</option>
            <option value="Primary (1st to 4th)">Primary (1st to 4th)</option>
            <option value="High School (5th to 10th)">High School (5th to 10th)</option>
            <option value="Junior College (11th to 12th)">Junior College (11th to 12th)</option>
            <option value="Diploma Course">Diploma Course</option>
            <option value="Graduation">Graduation</option>
            <option value="Post Graduation">Post Graduation</option>
            <option value="Professional Course">Professional Course</option>
            <option value="Administrative Course">Administrative Course</option>
            <option value="Educational Equipment ">Educational Equipment</option>
          </select>
        </div>

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Need Financial Help For</label>
          <input type="text" value={need_financial_help_for}
            onChange={(e) => setNeedFinancialHelpFor(e.target.value)}
            className={`form-control ${emptyFields.includes('need_financial_help_for') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Institution Name</label>
          <input type="text" value={institution_name}
            onChange={(e) => setInstitutionName(e.target.value)}
            className={`form-control ${emptyFields.includes('institution_name') ? 'error' : ''}`}
            style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Religion</label>

          <select
            className={`form-control ${emptyFields.includes('religion') ? 'error' : ''}`}
            onChange={(e) => setReligion(e.target.value)}
            value={religion}
            style={styles.input}
          >
            <option value="">Select</option>
            {allReligions && allReligions.map((religion) => (
              <option key={religion._id} data-pg={religion.title} value={religion.title}>{religion.title}</option>
            ))}
          </select>
        </div>

        {/* Caste and SubCaste dropdowns are hidden; empty strings are sent on submit */}

        <div style={styles.fieldContainer}>
          <label style={styles.label}>Student Whatsapp</label>
          <input type="text" value={student_whatsapp}
            onChange={(e) => setStudentWhatsapp(e.target.value)}
            className={`form-control ${emptyFields.includes('student_whatsapp') ? 'error' : ''}`}
            style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Email</label>
          <input type="email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`form-control ${emptyFields.includes('email') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Password</label>
          <input type="password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`form-control ${emptyFields.includes('password') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Father Whatsapp</label>
          <input type="text" value={father_whatsapp}
            onChange={(e) => setFatherWhatsapp(e.target.value)}
            className={`form-control ${emptyFields.includes('father_whatsapp') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Mother Whatsapp</label>
          <input type="text" value={mother_whatsapp}
            onChange={(e) => setMotherWhatsapp(e.target.value)}
            className={`form-control ${emptyFields.includes('mother_whatsapp') ? 'error' : ''}`}
            style={styles.input} />
        </div>
      </div>

      <div style={styles.fieldRow}>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Total Fees</label>
          <input type="number" value={total_fees}
            onChange={(e) => setTotalFees(e.target.value)}
            className={`form-control ${emptyFields.includes('total_fees') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Amount Already Arranged</label>
          <input type="number" value={arranged_amount}
            onChange={(e) => setArrangedAmount(e.target.value)}
            className={`form-control ${emptyFields.includes('arranged_amount') ? 'error' : ''}`}
            style={styles.input} />
        </div>
        <div style={styles.fieldContainer}>
          <label style={styles.label}>Payment Deadline</label>
          <input type="date" value={payment_deadline}
            onChange={(e) => setPaymentDeadline(e.target.value)}
            className={`form-control ${emptyFields.includes('payment_deadline') ? 'error' : ''}`}
            style={styles.input} />
        </div>
      </div>

      <a
        href="/terms"
        target="_blank"
        style={{ margin: '10px 0', display: 'block' }}
      >
        View Terms and Conditions
      </a>

      <Circles
        height="80"
        width="80"
        color="#4A90E2"
        ariaLabel="circles-loading"
        wrapperStyle={{
          justifyContent: "center",
          alignItems: "center",
        }}
        wrapperClass=""
        visible={loading}
      />

      <button type="submit" onClick={handleSubmit} style={styles.button}
        onMouseEnter={(e) => Object.assign(e.target.style, styles.hover)}
        onMouseLeave={(e) => Object.assign(e.target.style, styles.button)}
      >I Agree To Terms & Submit</button>
    </form>
  );
};


const styles = {
  form: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '5px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  fieldRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  fieldContainer: {
    flex: '1 1 calc(50% - 10px)',
    margin: '5px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    boxSizing: 'border-box',
  },

  button: {
    width: '100%',
    backgroundColor: '#E60240', // Accent color from the theme
    color: '#FFFFFF',
    padding: '12px 30px',
    fontSize: '1rem',
    fontWeight: '600',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },

  hover: {
    backgroundColor: '#c20035', // Darker red on hover
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
  },

};

export default StudentRegister;
